import { getCookie, removeCookie } from '#pplx/frontend/cookies/provider.js';
/**
 * Name and value shape are owned by the writer, authservice's
 * setCookieHomeHostHint (pplx/go/pkg/authservice/cookies.go). The value is a bare
 * HOSTNAME, not an origin: gin runs cookie values through url.QueryEscape, so an
 * origin would arrive as "https%3A%2F%2Fenterprise.perplexity.ai" and fail
 * `new URL()`, silently disabling every reader.
 */
const HOME_HOST_HINT_COOKIE = 'pplx.home-host';
/**
 * Must match the Domain authservice writes. js-cookie scopes a removal by Domain,
 * and the browser treats a differently-scoped cookie of the same name as a
 * different cookie — so a removal without this silently no-ops and the hint
 * survives, which is precisely the state that traps a user in a redirect loop
 * between the two hosts.
 */
const HOME_HOST_HINT_DOMAIN = '.perplexity.ai';
/**
 * The consumer host's only signal that an otherwise-anonymous browser belongs on
 * the enterprise host. Carries NO authority — it is a hostname, not a credential,
 * and anyone can set it on their own browser. Callers may use it to influence
 * routing and nothing else; treating its presence as "this user is authenticated"
 * is a vulnerability.
 */
export const getHomeHostHint = () => getCookie(HOME_HOST_HINT_COOKIE);
/**
 * Drops the hint so the consumer host stops routing this browser away. Needed
 * wherever a user must be able to escape the enterprise host — see the
 * consumer-not-allowed branch of auth-error-interstitial — and mirrored
 * server-side by clearCookieHomeHostHint on sign-out.
 */
export const clearHomeHostHint = () => {
    removeCookie(HOME_HOST_HINT_COOKIE, { domain: HOME_HOST_HINT_DOMAIN, path: '/' });
};
//# sourceMappingURL=homeHostHint.js.map